module.exports = __webpack_public_path__ + "static/media/marketing-grow-calendar-mb.a504aae9.png";